(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[715],{

/***/ 6715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ roomstay_notification; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./contexts/NotificationContext.tsx + 1 modules
var NotificationContext = __webpack_require__(4121);
;// CONCATENATED MODULE: ./hooks/useBodyResize.ts

var useBodyResize = function() {
    var ref = (0,react.useState)(0), marginTop = ref[0], setMarginTop = ref[1];
    var measuer = function(mutations, target) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === "style") {
                var marginT = Number.parseFloat((target.style.marginTop || "").replace("px", "")) || 0;
                setMarginTop(marginT);
                document.documentElement.style.setProperty("--app-banner-height", "".concat(target.style.marginTop));
            }
        });
    };
    (0,react.useEffect)(function() {
        var target = document.body;
        if (!target) return;
        var observer = new MutationObserver(function(mutations) {
            return measuer(mutations, target);
        });
        observer.observe(target, {
            attributes: true,
            attributeFilter: [
                "style"
            ]
        });
        return function() {
            return observer.disconnect();
        };
    }, []);
    return {
        marginTop: marginTop
    };
};

// EXTERNAL MODULE: ./components/roomstay-notification/roomstay-notification.module.scss
var roomstay_notification_module = __webpack_require__(4626);
var roomstay_notification_module_default = /*#__PURE__*/__webpack_require__.n(roomstay_notification_module);
;// CONCATENATED MODULE: ./components/roomstay-notification/roomstay-notification.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}






var Notification = function() {
    var ref3 = (0,react.useContext)(NotificationContext/* NotificationCtx */.b), messages = ref3.messages, isShowing = ref3.isShowing, setIsShowing = ref3.setIsShowing, popMessage = ref3.popMessage;
    var ref1 = (0,react.useState)(), currentMessage = ref1[0], setCurrentMessage = ref1[1];
    var notiRef = (0,react.useRef)(null);
    var ref2 = useBodyResize(), bodyMarginTop = ref2.marginTop;
    (0,react.useEffect)(function() {
        setCurrentMessage(popMessage());
    }, [
        messages
    ]);
    var measuer = (0,react.useCallback)(function() {
        var height = 0;
        if (!isShowing) {
            var ref;
            height = ((ref = notiRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().height) || 0;
        }
        document.documentElement.style.setProperty("--noti-height", "".concat(height + bodyMarginTop, "px"));
    }, [
        isShowing
    ]);
    (0,react.useEffect)(function() {
        setIsShowing(!!currentMessage);
    }, [
        currentMessage
    ]);
    (0,react.useEffect)(function() {
        if (!isShowing) {
            document.documentElement.style.setProperty("--noti-height", "0px");
        }
    }, [
        isShowing
    ]);
    (0,react.useEffect)(function() {
        if (!notiRef.current) return;
        var target = notiRef.current;
        var observer = new ResizeObserver(measuer);
        observer.observe(target, {
            box: "border-box"
        });
        return function() {
            return observer.unobserve(target);
        };
    }, []);
    var _onClose = function() {
        if (currentMessage && currentMessage.id) {
            // localStorage.setItem(currentMessage.id, 'true');
            setCurrentMessage(undefined);
        }
    };
    var closeable = !(currentMessage === null || currentMessage === void 0 ? void 0 : currentMessage.preventClosing);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((roomstay_notification_module_default()).container, _defineProperty({}, (roomstay_notification_module_default()).haveContent, !!currentMessage)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((roomstay_notification_module_default()).box, (roomstay_notification_module_default()).warning, "container"),
            ref: notiRef,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (roomstay_notification_module_default()).background
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (roomstay_notification_module_default()).main,
                    children: [
                        currentMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (roomstay_notification_module_default()).messageContent,
                            dangerouslySetInnerHTML: {
                                __html: currentMessage.content
                            }
                        }) : null,
                        closeable ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: (roomstay_notification_module_default()).closeButton,
                            onClick: _onClose,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (roomstay_notification_module_default()).closeIcon
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var roomstay_notification = (Notification);


/***/ }),

/***/ 4626:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"roomstay-notification_container__s8ZIZ","box":"roomstay-notification_box__GqY4d","background":"roomstay-notification_background__mBUgw","main":"roomstay-notification_main__zZLee","messageContent":"roomstay-notification_messageContent__cTwNz","closeButton":"roomstay-notification_closeButton__WpE3T","closeIcon":"roomstay-notification_closeIcon__crBVs","haveContent":"roomstay-notification_haveContent__TMCKP"};

/***/ })

}]);